
export type TooltipPlacement =
  'bottom-end' | 'bottom-start' | 'bottom' |
  'left-end' | 'left-start' | 'left' |
  'right-end' | 'right-start' | 'right' |
  'top-end' | 'top-start' | 'top';

export const enum SortDirection
{
  ascending = 0,
  descending = 1,
  alphabetical = 0,
  reverseAlphabetical = 1,
}

export type SortFn = ((a: number, b: number) => number) | ((a: string, b: string) => number);


export interface TableHeading
{
  Header: string,
  accessor: string,
  tooltip?: string,
  sortDirection?: SortDirection | null,
  setSortDirection?: (value: React.SetStateAction<SortDirection | null>) => void,
  sortFn?: SortFn;
}